module.exports = __webpack_public_path__ + "static/media/campus_15.70ce2d4b.png";